/** @format */

import { AvailableWarrantiesBody, AvailableWarrantiesResponse } from '@pdp/data-access/interfaces';
import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { Injectable, inject } from '@angular/core';

import { Environment } from '@shared/data-access/interfaces';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class NonMerchAvailabilityDao {
	http = inject(HttpClient);
	environment = inject(Environment);

	private readonly DEFAULT_HTTP_HEADER_PROPERTIES = {
		Accept: MediaType.APPLICATION_JSON,
		'Content-Type': MediaType.APPLICATION_JSON
	};

	public getAvailableWarranties(body: AvailableWarrantiesBody) {
		const httpOptions = {
			headers: {
				...this.DEFAULT_HTTP_HEADER_PROPERTIES,
				[CustomHttpHeaders.X_TIMEOUT]: `${this.environment.api.nonmerch.timeout}`
			}
		};

		return this.http.post<AvailableWarrantiesResponse>(
			`${this.environment.api.nonmerch.baseUrl}/available/warranties`,
			body,
			httpOptions
		);
	}
}
